import { useWatch } from 'react-hook-form';
import { useIntl } from 'react-intl';
import { tiktokDisclosureMessages as messages } from './tiktok-disclosure-messages';

/**
 * Watches TikTok disclosure form fields and derives state for the disclosure settings UI:
 * disclosure on/off, selection flags, validation hints, and the info alert message.
 */
export function useTiktokDisclosureState() {
  const { formatMessage } = useIntl();
  const discloseVideoContent = useWatch({ name: 'discloseVideoContent' });
  const brandOrganic = useWatch({ name: 'brandOrganic' });
  const brandContent = useWatch({ name: 'brandContent' });
  const privacyLevel = useWatch({ name: 'privacyLevel' });

  const isDisclosureOn = Boolean(discloseVideoContent);
  const hasYourBrand = Boolean(brandOrganic);
  const hasBrandedContent = Boolean(brandContent);
  const noneSelected = isDisclosureOn && !hasYourBrand && !hasBrandedContent;
  const hasBrandedContentPrivacyConflict =
    isDisclosureOn && hasBrandedContent && privacyLevel === 'SELF_ONLY';

  const alertMessage = noneSelected
    ? formatMessage(messages.selectAtLeastOneHint)
    : hasBrandedContent
      ? formatMessage(messages.labelPaidPartnershipAlert)
      : formatMessage(messages.promotionalLabel);

  return {
    isDisclosureOn,
    noneSelected,
    hasBrandedContent,
    hasBrandedContentPrivacyConflict,
    alertMessage,
  };
}
